import http from './http';

const mapItems = (res) => res.data?.data?.cities ?? res.data?.items ?? res.data?.data ?? res.data ?? [];

export async function listGenders() {
  const res = await http.get('/genders/available');
  return mapItems(res);
}
export async function listPeriods() {
  const res = await http.get('/periods/available');
  return mapItems(res);
}
export async function listModalities() {
  const res = await http.get('/modalities/available');
  return mapItems(res);
}

export async function listCompetitionStatuses() {
  const res = await http.get('/competition-statuses/available');
  return mapItems(res);
}

export async function listCompetitionCriteria() {
  const res = await http.get('/evaluation-criteria/available');
  return mapItems(res);
}

export async function listCompetitionJudges() {
  const res = await http.get('/users/judges/available');
  return mapItems(res);
}

export async function listCompetitionRegions() {
  const res = await http.get('/regions/available');
  return mapItems(res);
}


export async function listPlans() {
  const res = await http.get('/plans/available');
  return mapItems(res);
}

export async function listClientRoles() {
  const res = await http.get('/client-roles/available');
  return mapItems(res);
}

export async function listStates() {
  const res = await http.get('/states/available');
  return mapItems(res);
}

export async function listAllStates() {
  const res = await http.get('/states');
  return mapItems(res);
}

export async function listJerseySizes() {
  const res = await http.get('/jersey-sizes/available');
  return mapItems(res);
}

export async function listFieldTypes() {
  const res = await http.get('/field-types/available');
  return mapItems(res);  
}

export async function listPlayerPositions() {
  const res = await http.get('/player-positions/available');
  return mapItems(res);  
}

export async function listPlayFrequencies() {
  const res = await http.get('/play-frequencies/available');
  return mapItems(res);  
}

export async function listDominantFoot() {
  const res = await http.get('/dominant-foot/available');
  return mapItems(res);  
}

export async function listPersonalInterests() {
  const res = await http.get('/personal-interests/available');
  return mapItems(res);  
}

export async function listPurchaseFrquencies() {
  const res = await http.get('/purchase-frequencies/available');
  return mapItems(res);  
}

export async function listSupportReasons() {
  const res = await http.get('/support-reasons/available');
  return mapItems(res);  
}

export async function listTeams() {
  const res = await http.get('/team');
  return mapItems(res);  
}

export async function listCitiesByState(id, value = null) {
  const res = await http.get(`/city/filter/?stateId=${id}&page=1&size=100${value ? '&search='+value : ''}`);
  return mapItems(res);  
}

export async function listCategoryEquipment() {
  const res = await http.get('/team-categories/available');
  return mapItems(res);  
}

export async function listTemplateSizes() {
  const res = await http.get('/template-sizes/available');
  return mapItems(res);  
}

export async function listUserRoleTypes() {
  const res = await http.get('/client-roles/available');
  return mapItems(res);  
}

export async function listEvaluationStatuses() {
  const res = await http.get('/evaluation-statuses/available');
  return mapItems(res);
}

export async function listCompetitions() {
  const res = await http.get('/competitions/available');
  return mapItems(res);
}

export async function listAvailableJudges(id) {
  const res = await http.get('/users/judges/available/'+id);
  return mapItems(res);
}

export async function listTeamSizes() {
  const res = await http.get('/team-sizes/available');
  return mapItems(res);  
}